import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import "../../styles/pages/RunValidationCheckModal.scss";
import RunValidationCheckTable from "./RunValidationCheckTable";
const RunValidationCheckModal = ({
  setRunValidationCheckEnabled,
  showBannerName,
  data,
}) => {
  return (
    <>
      <Dialog
        open={true}
        //   onClose={}
        className="run-validation-check-container"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <div className="run-validation-check-innercontainer">
          <div className="must-use-text">
            <div className="must-use-element-not-used-text1">
              {`MUST EXIST ELEMENTS NOT USED IN ${showBannerName}`}
            </div>
            <div className="must-use-element-not-used-text2">
              {`Following Must Exist elements are not used to author ${showBannerName}`}
            </div>
          </div>
        </div>
        <RunValidationCheckTable data={data} />
        <DialogActions className="modalActions validationCheckCancelFoooter">
          <Button
            onClick={() => {
              setRunValidationCheckEnabled(false);
            }}
            color="primary"
            className="checkCancelBtn"
          >
            {"Close"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default RunValidationCheckModal;
